/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_User_GuidesInputs */



/**
* | output |
* | --- |
* | "User Guides" |
*
* @param {Help_User_GuidesInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const help_user_guides = /** @type {((inputs?: Help_User_GuidesInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_User_GuidesInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Guides utilisateur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guías de usuario")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Guias do usuário")
	if (locale === "it") return /** @type {LocalizedString} */ ("Guide utente")
	return /** @type {LocalizedString} */ ("User Guides")
});